import { 
    Col, 
    Container, 
    Row,
    FormGroup,
    Input, 
    Label,
    Button
} from "reactstrap";

import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import Icon from '@mui/material/Icon';

function SuccessPage(){
    return(
        <Container style={{marginTop: '6rem', textAlign: "center"}}>
            <Row>
                <Col> 
                    <DoneOutlineIcon style={{color:'green', fontSize: '4rem'}}/>
                </Col>
            </Row>
            <Row style={{marginTop:'1rem'}}>
                <Col>
                    <h2>Tudo certo!</h2>
                </Col>
            </Row>
            <Row>
                <Col>
                    <h3>Por favor, verifique a sua caixa de e-mail.</h3>
                </Col>
            </Row>
            <Row style={{marginTop:'2rem'}}>
                <Col>
                    <Button size="lg"  style={{backgroundColor: '#32699A'}} onClick={() => { window.location.href = "https://pdpre.interplayers.com.br/11v1/" }}>
                        Voltar para o Portal da Drogaria
                    </Button>
                </Col>
            </Row>
        </Container>
    )
}

export default SuccessPage;